import { schema } from "normalizr";
const application = new schema.Entity("applications", undefined, {
  idAttribute: "applicationId"
});
export const clientsSchema = new schema.Entity("clients", {
  applications: [application]
}, {
  idAttribute: "username"
});
export const applicationsSchema = new schema.Entity("applications", {
  applications: [application]
}, {
  idAttribute: "applicationId"
});